import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import VideoPreview from "./VideoPreview/VideoPreview";
import VideoCropper from "./VideoCropper/VideoCropper";

export default function PreviewPanel() {
  const cropperState = useEditorStore((state) => state.cropperState);

  if (cropperState) {
    return (
      <VideoCropper
        key={
          cropperState.timelineItemExternalId +
          cropperState.animatedImageExternalId
        }
        cropperState={cropperState}
      />
    );
  }

  return <VideoPreview />;
}
